var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-event-log-item',{attrs:{"icon":_vm.icon,"icon-color":_vm.iconColor,"researcher":_vm.referenceEventLog.eventBy,"date":_vm.referenceEventLog.createdAt,"bottom-node":_vm.bottomNode}},[_c('div',{staticClass:"text-overflow-ellipsis"},[(
        _vm.referenceEventLog.event ===
        _vm.ReferenceEvent.FULL_TEXT_PDF_FETCH_STARTED
      )?_c('span',[_vm._v(" Started searching for a full-text PDF. ")]):(
        _vm.referenceEventLog.event ===
        _vm.ReferenceEvent.FULL_TEXT_PDF_FETCH_NOT_FOUND
      )?_c('span',[_vm._v(" No direct PDF was found. Many publishers restrict downloads. ")]):(
        _vm.referenceEventLog.event ===
        _vm.ReferenceEvent.FULL_TEXT_PDF_FETCH_ERROR
      )?_c('span',[_vm._v(" Error fetching full-text PDF "),(_vm.error)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
      var on = ref.on;
return [_c('v-icon',_vm._g({staticClass:"ml-1",attrs:{"x-small":""}},on),[_vm._v("info")])]}}],null,false,2709718545)},[_c('span',[_vm._v(_vm._s(_vm.error))])]):_vm._e()],1):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }